import ShareIcon from '@mui/icons-material/Share';
import { styled } from '@mui/material';

export const StyledReportIcon = styled(ShareIcon)`
    margin-right: 5px;
    font-size: 17px;
`;